// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Line {
	display: flex;
	width: 100%;
	height: 70px;
	margin-top: -2%;
	position: relative;
	min-height: 70px;
	margin-bottom: 10px;
}

.Lane {
	position: absolute;
	width: 100%;
	height: 100%;
	background-repeat: repeat-x;
	background-size: contain;
	background-position: bottom;
	top: 0;
}

:root {
  --colour1: #a5e928;
  --colour_gray: #ebebeb;
  --colour2: #959da5;
  --colour3: #5c7767;
  --speed: 2s;
  --patternRepeatWidth: 37;
  --stripeWidth: calc(var(--patternRepeatWidth) * 1px);
  --fundamentalBase: calc(1px * sqrt(2 * pow(var(--patternRepeatWidth), 2)));
}

@keyframes slide {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: var(--fundamentalBase);
  }
}

/* Progress bar container and styles */
.progressBarContainer {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  height: 24px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 
    0 4px 15px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.progressBarBackground {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, 
    rgba(149, 157, 165, 0.3) 0%, 
    rgba(149, 157, 165, 0.2) 100%
  );
}

.progressBarFill {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: linear-gradient(90deg, 
    #a5e928 0%, 
    #7cb518 50%, 
    #a5e928 100%
  );
  border-radius: 12px;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 0 20px rgba(165, 233, 40, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.progressBarFill::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.4) 50%, 
    transparent 100%
  );
  animation: shimmer 2s infinite;
}

.progressBarGlow {
  position: absolute;
  top: -2px;
  left: 0;
  bottom: -2px;
  background: linear-gradient(90deg, 
    rgba(165, 233, 40, 0.6) 0%, 
    rgba(124, 181, 24, 0.4) 100%
  );
  border-radius: 14px;
  filter: blur(2px);
  opacity: 0.7;
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Line.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,wBAAwB;CACxB,2BAA2B;CAC3B,MAAM;AACP;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,oDAAoD;EACpD,0EAA0E;AAC5E;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;EAC1C;;0CAEwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;GAGC;AACH;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT;;;;GAIC;EACD,mBAAmB;EACnB,mDAAmD;EACnD;;0CAEwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ;;;GAGC;EACD,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".Line {\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 70px;\n\tmargin-top: -2%;\n\tposition: relative;\n\tmin-height: 70px;\n\tmargin-bottom: 10px;\n}\n\n.Lane {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: repeat-x;\n\tbackground-size: contain;\n\tbackground-position: bottom;\n\ttop: 0;\n}\n\n:root {\n  --colour1: #a5e928;\n  --colour_gray: #ebebeb;\n  --colour2: #959da5;\n  --colour3: #5c7767;\n  --speed: 2s;\n  --patternRepeatWidth: 37;\n  --stripeWidth: calc(var(--patternRepeatWidth) * 1px);\n  --fundamentalBase: calc(1px * sqrt(2 * pow(var(--patternRepeatWidth), 2)));\n}\n\n@keyframes slide {\n  from {\n    background-position-x: 0;\n  }\n  to {\n    background-position-x: var(--fundamentalBase);\n  }\n}\n\n/* Progress bar container and styles */\n.progressBarContainer {\n  position: absolute;\n  bottom: 15px;\n  left: 0;\n  right: 0;\n  height: 24px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  overflow: hidden;\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: \n    0 4px 15px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n.progressBarBackground {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, \n    rgba(149, 157, 165, 0.3) 0%, \n    rgba(149, 157, 165, 0.2) 100%\n  );\n}\n\n.progressBarFill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: linear-gradient(90deg, \n    #a5e928 0%, \n    #7cb518 50%, \n    #a5e928 100%\n  );\n  border-radius: 12px;\n  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: \n    0 0 20px rgba(165, 233, 40, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.progressBarFill::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, \n    transparent 0%, \n    rgba(255, 255, 255, 0.4) 50%, \n    transparent 100%\n  );\n  animation: shimmer 2s infinite;\n}\n\n.progressBarGlow {\n  position: absolute;\n  top: -2px;\n  left: 0;\n  bottom: -2px;\n  background: linear-gradient(90deg, \n    rgba(165, 233, 40, 0.6) 0%, \n    rgba(124, 181, 24, 0.4) 100%\n  );\n  border-radius: 14px;\n  filter: blur(2px);\n  opacity: 0.7;\n  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: -1;\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
